export enum ConfigScopes {
    Configuration = 32,
    Global = 16,
    Partner = 8,
    Region = 4,
    Timeslot = 2,

}